import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export default {
  // 查询抢购商品列表
  getseckillgoodslist: option => {
    return request3('v1/seckill/getseckillgoodslist', option, true)
  },
  // 查询已发布的抢购商品列表
  getongoingseckillgoodslist: option => {
    return request3('v1/seckill/getongoingseckillgoodslist', option, true)
  },
  // 查询抢购商品详情
  getseckillgoods: option => {
    const urls = urlStringify(option)
    return request3('v1/seckill/getseckillgoods' + urls, {}, true)
  },
  // 增加抢购商品
  addseckillgoods: option => {
    return request3('v1/seckill/addseckillgoods', option, true)
  },
  // 修改抢购商品
  updateseckillgoods: option => {
    return request3('v1/seckill/updateseckillgoods', option, true)
  },
  // 删除抢购商品
  deleteseckillgoods: option => {
    const urls = urlStringify(option)
    return request3('v1/seckill/deleteseckillgoods' + urls, {}, true)
  },
  // 发布抢购商品
  publishseckillgoods: option => {
    return request3('v1/seckill/publishseckillgoods', option, true)
  },
  // 关闭抢购商品
  closeseckillgoods: option => {
    const urls = urlStringify(option)
    return request3('v1/seckill/closeseckillgoods' + urls, {}, true)
  }
}
